import "./ProductItem.css";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchProducts, fetchProductTypes } from "./Data";

const ProductItem = ({ isSearchVisible }) => {
  const [products, setProducts] = useState([]);
  const [productTypes, setProductTypes] = useState([]);
  const [filters, setFilters] = useState({});
  const [selectedCategory, setSelectedCategory] = useState("All Products");

  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  useEffect(() => {
    handleCategorySelect("All Products");
  }, []);

  const toggleMenu = () => {
    setIsMenuVisible(!isMenuVisible);
    if (!isMenuVisible) setIsFilterVisible(false);
  };

  const toggleFilter = () => {
    setIsFilterVisible(!isFilterVisible);
    if (!isFilterVisible) setIsMenuVisible(false);
  };

  const handleFilterChange = (filter) => {
    setFilters((prev) => ({
      ...prev,
      [filter]: !prev[filter],
    }));
  };

  const handleCategorySelect = async (category) => {
    setSelectedCategory(category);
    setIsMenuVisible(false);

    const lower = category.toLowerCase();

    // Fetch product types dynamically
    const types = await fetchProductTypes(lower);
    setProductTypes(types);

    // Create filters from types
    const newFilters = types.reduce((acc, type) => {
      acc[type] = false;
      return acc;
    }, {});
    setFilters(newFilters);

    // Fetch products
    const fetchedProducts = await fetchProducts(lower);
    setProducts(fetchedProducts);
  };

  const hasActiveTypeFilters = Object.values(filters).some(Boolean);

  const filteredProducts = products.filter((product) => {
    if (!hasActiveTypeFilters) return true;
    return filters[product.type];
  });

  const productElements = filteredProducts.length ? (
    filteredProducts.map((product) => (
      <Link
        to={`/product/${product.id}`}
        key={product.id}
        className="item"
        data-type={product.type}
        data-material={product.material}
      >
        <div className="image">
          <img src={`https://app.jp-jewelrypart.com/${product.image}`} alt={product.name} />
        </div>
        <p className="name">{product.name}</p>
      </Link>
    ))
  ) : (
    <p className="no-products">
      No products found based on the selected filters.
    </p>
  );

  return (
    <div>
      <nav>
        <div className="left-icons">
          <button className="nav_toggle btn-icon" onClick={toggleMenu}>
            <i className="bx bx-menu"></i>
          </button>
          <button className="filter_toggle btn-icon" onClick={toggleFilter}>
            <i className="bx bx-plus"></i>
          </button>
        </div>

        <div className={`nav_Item ${isMenuVisible ? "show" : ""}`}>
          {["All Products", "Gold", "Silver", "Bronze", "Accessory"].map(
            (cat) => (
              <React.Fragment key={cat}>
                <a
                  href={`#${cat.toLowerCase()}`}
                  className="manage nav-btn"
                  onClick={() => handleCategorySelect(cat)}
                >
                  {cat}
                </a>
                <br />
                <br />
              </React.Fragment>
            )
          )}
          <h1 className="com">{selectedCategory}</h1>
        </div>
      </nav>

      <main className="main-0">
        <aside className={`filter-aside ${isFilterVisible ? "show" : ""}`}>
          <h3>Categories</h3>
          {productTypes.map((type) => (
            <div className="checkbox-wrapper-42" key={type}>
              <input
                id={`filter${type}`}
                type="checkbox"
                checked={filters[type] || false}
                onChange={() => handleFilterChange(type)}
              />
              <label className="cbx" htmlFor={`filter${type}`}></label>
              <label className="lbl" htmlFor={`filter${type}`}>
                {type}
              </label>
            </div>
          ))}
        </aside>

        <h1 className={`phone ${isSearchVisible ? "search-show" : ""}`}>
          {selectedCategory}
        </h1>

        <div className="product-grid">{productElements}</div>
      </main>
    </div>
  );
};

export default ProductItem;
